/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unexpectederroroccurred2Inputs */

const en_unexpectederroroccurred2 = /** @type {(inputs: Unexpectederroroccurred2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unexpected error occurred.`)
};

const de_unexpectederroroccurred2 = /** @type {(inputs: Unexpectederroroccurred2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein unerwarteter Fehler ist aufgetreten.`)
};

/**
* | output |
* | --- |
* | "An unexpected error occurred." |
*
* @param {Unexpectederroroccurred2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const unexpectederroroccurred2 = /** @type {((inputs?: Unexpectederroroccurred2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unexpectederroroccurred2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unexpectederroroccurred2(inputs)
	return de_unexpectederroroccurred2(inputs)
});
export { unexpectederroroccurred2 as "unexpectedErrorOccurred" }